import { ThunkType } from "../../../../core/store/reducers";
import deleteCityApi from "../api/deleteCity";
import { setFetchState } from "../citiesDataReducer";

export const deleteCity = (cityId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteCityApi(userId, cityId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
};
